import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    pendingCall: null,
    pendingNavigation: null,
};

const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        requestCall(state, action) {
            state.pendingCall = action.payload;
        },
        clearCall(state) {
            state.pendingCall = null;
        },
        requestNavigation(state, action) {
            state.pendingNavigation = action.payload;
        },
        clearNavigation(state) {
            state.pendingNavigation = null;
        },
    },
});

export const { requestCall, clearCall, requestNavigation, clearNavigation } = commonSlice.actions;
export const commonReducers = {
    common: commonSlice.reducer,
};
export const commonReducer = commonSlice.reducer;
export default commonSlice;
